import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, HAS_INSTANT_DISCOUNT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import { TermsOfSalesPageContainer } from './TermsOfSalesPageStyle';
import { getI18nByApp } from '../../../services/i18n/selector';

class TermsOfSalesPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n, i18nCommon } = this.props;

        const discountedPlural = HAS_INSTANT_DISCOUNT ? i18nCommon.DISCOUNTED_PLURAL : '';

        return (
            <TermsOfSalesPageContainer className="conteneur conteneur-mobile" id="p-cgv">
                <HeadComponent
                    title={getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE')}
                    description={getI18nByApp(i18n, 'page.TERMS_OF_SALES.DESCRIPTION')}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {getI18nByApp(i18n, 'page.TERMS_OF_SALES.BREADCRUMB')}
                </LocalizedBreadcrumbItem>
                <h1>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE')}</h1>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE1')}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT1_1'),
                        CONTEXT_ROOT
                    )}
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT1_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT1_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT1_4')}</p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT1_5'),
                        CONTEXT_ROOT
                    )}
                </p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE2')}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT2_1'),
                        CONTEXT_ROOT,
                        discountedPlural
                    )}
                </p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT2_2'),
                        discountedPlural
                    )}
                </p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT2_3'),
                        discountedPlural
                    )}
                </p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE3')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT3_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT3_2')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE4')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT4_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT4_2')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE5')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT5_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT5_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT5_3')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE6')}</h3>
                <p>
                    <b>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_1')}</b>
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_2')}</p>
                <p>
                    <u>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_3')}</u>
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_4')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_9')}</p>
                <p>
                    <b>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_10')}</b>
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_11')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_12')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_13')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_14')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT6_15')}</li>
                </ul>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE7')}</h3>
                <p>
                    <b>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT7_1'),
                            discountedPlural
                        )}
                    </b>
                </p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT7_2'),
                        discountedPlural
                    )}
                </p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE8')}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT8_1'),
                        discountedPlural
                    )}
                </p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE9')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT9_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT9_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT9_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT9_4')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TITLE10')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT10_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT10_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT10_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS_OF_SALES.TEXT10_4')}</p>
            </TermsOfSalesPageContainer>
        );
    }
}

TermsOfSalesPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        i18nCommon: state.i18n.common
    };
}

export default withTemplate(connect(mapStateToProps)(TermsOfSalesPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/termsofsales/TermsOfSalesPage.js